import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext } from "preact/hooks";
import { setCurrent } from "./currentTaskSlice";
import { subappToName } from "./data";
import { Observer } from "./experiment";
import { useAppDispatch, useAppSelector } from "./hooks";
import { markComplete, markIncomplete, selectIsComplete } from "./tasksSlice";
const TaskWrapper = (props) => {
    const { id } = props;
    const isComplete = useAppSelector((state) => selectIsComplete(state, id));
    const dispatch = useAppDispatch();
    const observer = useContext(Observer);
    return (_jsx(Task, { checked: isComplete, setCheck: (v) => {
            if (v) {
                observer.observe({ type: "complete", id, why: "checked" });
            }
            dispatch(v ? markComplete(id) : markIncomplete(id));
        }, preNavigate: () => {
            dispatch(setCurrent(id));
        }, ...props }));
};
export const Tasks = () => {
    const observer = useContext(Observer);
    const exp = observer.selectedExperiment();
    const tasks = exp.tasks.map(TaskWrapper);
    return _jsxs("ul", { className: "flow", children: [...tasks] });
};
export const Task = (props) => {
    return (_jsxs("li", { className: "task card", "data-complete": props.checked, children: [_jsx("input", { type: "checkbox", checked: props.checked, onClick: () => {
                    props.setCheck(!props.checked);
                } }), _jsxs("div", { className: "card-content", children: [_jsx("h1", { children: _jsx("a", { href: props.subapp, onClick: props.preNavigate, children: props.name }) }), _jsx("p", { children: props.caption ??
                            `Complete task in ${subappToName[props.subapp] ?? props.subapp}` })] })] }));
};
